import { useMutation } from "react-query";

import { AxiosRequestConfig } from "axios";
import http from "infra/http";
import { useCurrentTenant } from "core/features/auth/tenant.store";

export default function useSaveBankAccount(tenantId?: string) {
  const { tenant } = useCurrentTenant();
  const url: string = `/v1/tenants/${tenant.id}/conta-bancaria`;
  const editId = (id: string) =>
    `/v1/tenants/${tenant.id}/conta-bancaria/${id}`;
  const config: AxiosRequestConfig = {
    params: {
      tenantId: tenantId || tenant.id,
    },
  };
  
  return useMutation<any, any, any, any>(
    [url],
    async (body: any) => {
      if (body.id) {
        const { data } = await http.put(editId(body.id), body, config);
        return data;
      }
      const { data } = await http.post(url, body, config);
      return data;
    }
  );
}
